function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.455,9.126L16.932,1.731C17.168,1.486 17.163,1.096 16.916,0.859C16.674,0.629 16.291,0.629 16.049,0.859L9.016,7.819L1.981,0.859C1.739,0.619 1.346,0.619 1.101,0.859C0.859,1.1 0.859,1.49 1.101,1.731L8.575,9.126C8.82,9.367 9.213,9.367 9.455,9.126Z",
    style: {
      fill: "rgb(51,51,51)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.1ce944f006e8925d980ded957f6f4a38.svg";
export { ForwardRef as ReactComponent };